export * from './AppBadges';

//# sourceMappingURL=index.js.map